import { Cohort } from 'root-constants'

export const getTestCohortToOverride = (features: {
  isKarma36IntroPriceSelect: boolean
}): Cohort | undefined => {
  if (features.isKarma36IntroPriceSelect) return Cohort.KP_BS_13_H

  return undefined
}
